module.exports = __webpack_public_path__ + "static/media/5.2601e5c2.png";